$(() => {
    $(document).on('click','.js-copy',function () {
        var text =  document.getElementById("js-clipboardText");

        $(this).addClass('cliped').delay(3000).queue(function(next){
            $(this).removeClass('cliped');
            next();
        });
        text.select();
        document.execCommand("copy");
    });
});
